import React from 'react';
import { Home, Phone, Info, Factory, DollarSign, Settings, AlertTriangle } from 'lucide-react';

const Navigation = ({ activeSection, onSectionChange, isAdmin }) => {
  const navItems = [
    { id: 'inventory', label: 'Dealer Inventory', icon: Home },
    { id: 'factory', label: 'Factory Direct', icon: Factory },
    { id: 'rebates', label: 'Rebates Schedule', icon: DollarSign },
    { id: 'issues', label: 'Issues', icon: AlertTriangle },
    { id: 'contact', label: 'Contact', icon: Phone },
    { id: 'about', label: 'About', icon: Info },
  ];

  // Add Admin to nav items if user is admin
  if (isAdmin) {
    navItems.push({ id: 'admin', label: 'Admin', icon: Settings });
  }

  // Check if current section is an issue-related section
  const isIssueSection = ['issues', 'issues-submit', 'issues-detail', 'issues-admin'].includes(activeSection);

  return (
    <nav className="app-navigation">
      <div className="nav-container">
        {navItems.map(item => {
          const Icon = item.icon;
          const isActive = item.id === 'issues' 
            ? isIssueSection 
            : activeSection === item.id;
          return (
            <button
              key={item.id}
              className={`nav-item ${isActive ? 'active' : ''}`}
              onClick={() => onSectionChange(item.id)}
            >
              <Icon size={18} />
              <span>{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default Navigation;
